import { render, staticRenderFns } from "./RecorderVoice.vue?vue&type=template&id=ba8ef208"
import script from "./RecorderVoice.vue?vue&type=script&lang=js"
export * from "./RecorderVoice.vue?vue&type=script&lang=js"
import style0 from "./RecorderVoice.vue?vue&type=style&index=0&id=ba8ef208&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTooltip});
